import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './personal-note.types';

export const personalNoteSelectors = {
  ...generateResourceSelectors<types.IPersonalNote>((state) => state.resource.personalNote),
};
